module.exports = __webpack_public_path__ + "assets/b67.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b67.png
// module id = 657
// module chunks = 0